<template>
  <div class="result-module">
    <div class="main-module">
      <div class="module-header">
        <p class="header-title">战队赛程</p>
      </div>
      <div class="module-content">
        <p class="current-game-info">近3天暂无比赛</p>
        <a class="view-all-games">查看全部赛程></a>
      </div>
    </div>
    <div class="main-module">
      <div class="module-header">
        <p class="header-title">战队战绩</p>
      </div>
      <div class="module-content pd48">
        <p class="rank-bg">青龙战区第5名</p>
        <ul class="rank-data">
          <li>
            <p class="data-num">46534</p>
            <p class="describe">赛季累计奖杯数</p>
          </li>
          <li>
            <p class="data-num">46534</p>
            <p class="describe">胜率</p>
          </li>
          <li>
            <p class="data-num">46534</p>
            <p class="describe">PK胜率</p>
          </li>
          <li>
            <p class="data-num">46534</p>
            <p class="describe">平均每局奖杯数</p>
          </li>
        </ul>
        <a class="share-btn">
          <i class="shart-icon"></i>
          查看海报
        </a>
      </div>
    </div>
    <div class="main-module">
      <div class="module-header">
        <p class="header-title">战队荣誉</p>
      </div>
      <div class="module-content pd48">
        <p class="rank-bg">三连胜战队</p>
        <p class="acquire-time">2023-05-13获得</p>
        <p class="acquire-describe">连续三天战队赢得胜利</p>
        <a class="share-btn">
          <i class="shart-icon"></i>
          查看海报
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.result-module {
    position: relative;
    top: -120px;
    .main-module {
      margin-bottom: 40px;
    }
    .module-header {
      width: 550px;
      height: 72px;
      margin: 0 auto;
      background: url('~@images/winterGame/line.png') no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .header-title {
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
      }
    }
    .module-content {
      width: 622px;
      margin: 0 auto;
      background: #FFFFFF;
      border-radius: 8px;
      .current-game-info {
        padding-top: 48px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        text-align: center;
      }
      .view-all-games {
        padding: 32px;
        display: block;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58ABF6;
        text-align: right;
      }
      .rank-bg {
        position: relative;
        top: 24px;
        height: 88px;
        background: #E4F1FD;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        text-align: center;
        line-height: 88px;
      }
      .rank-data {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .data-num {
            font-size: 48px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            margin: 0 0 8px 0;
            padding: 0;
          }
          .describe {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #68707D;
            margin: 0 0 32px 0;
            padding: 0;
          }
        }
      }
      .acquire-time {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707D;
        line-height: 40px;
        text-align: center;
      }
      .acquire-describe {
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444B65;
        line-height: 44px;
        text-align: center;
      }
      .share-btn {
        width: 312px;
        height: 64px;
        margin: 0 auto;
        background: #58ABF6;
        border-radius: 32px;
        border: 2px solid #58ABF6;
        display: flex;
        align-items: center;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        justify-content: center;
        .shart-icon {
          width: 32px;
          height: 32px;
          margin-right: 12px;
          background: url('~@images/winterGame/share.png') no-repeat;
          background-size: 100%;
        }
      }
      &.pd48 {
        padding-bottom: 48px;
      }
    }
  }
</style>
